/**
 * @voltxampere/ui — MP1584 buck switching regulator variant (Sprint 42-2)
 *
 * SOIC-8 high-frequency buck regulator. V_in 4.5-28 V, V_out
 * adjustable 0.8-25 V (default 5 V), I_out 3 A, switching frequency
 * 1.5 MHz (smaller external inductor than LM2596's 150 kHz). The
 * Sprint 4 vdc stamp idealizes the output; real switching
 * simulation Sprint 50+.
 *
 * Reference: Monolithic Power MP1584. Engine zero-diff invariant
 * honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const regulatorMp1584 = {
    id: "mp1584",
    nameTr: "MP1584 (Buck Anahtarlamalı +5V, SOIC-8)",
    nameEn: "MP1584 (Buck Switching +5V, SOIC-8)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "MP1584",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=regulator-mp1584.js.map